/* eslint-disable */
import { TextStyle } from './common';
const baseHeadingData = { level: 0 };
export const HeadingData = {
    fromJSON(object) {
        const message = Object.assign({}, baseHeadingData);
        message.level = object.level !== undefined && object.level !== null ? Number(object.level) : 0;
        message.textStyle =
            object.textStyle !== undefined && object.textStyle !== null
                ? TextStyle.fromJSON(object.textStyle)
                : undefined;
        message.indentation =
            object.indentation !== undefined && object.indentation !== null
                ? Number(object.indentation)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.level !== undefined && (obj.level = Math.round(message.level));
        message.textStyle !== undefined &&
            (obj.textStyle = message.textStyle ? TextStyle.toJSON(message.textStyle) : undefined);
        message.indentation !== undefined && (obj.indentation = message.indentation);
        return obj;
    },
};
//# sourceMappingURL=node_heading.js.map